import { HallowAnalyticsEvent } from "@packages/analytics";
import { Link } from "@packages/framework";
import type { TriviaSectionItem } from "@packages/sdk";
import { differenceInHours } from "date-fns/differenceInHours";

import type { CSSColorStrict } from "../../../../../utils/colors/types/CSSColorStrict.types";
import { Button } from "../../../_core/Button/Button.emotion";
import type { TriviaLargeProps } from "../../trivia/TriviaLarge/TriviaLarge.emotion";
import type { BaseGetSectionItemProps } from "./Section.emotion";

export type GetSectionItemTriviaPropsProps =
  BaseGetSectionItemProps<TriviaSectionItem>;

export const getSectionItemTriviaProps = ({
  item,
  link,
  t,
  analytics,
}: GetSectionItemTriviaPropsProps): TriviaLargeProps => {
  const triviaUnstarted = item?.reference?.state === "UNSTARTED";
  const triviaFinished = item?.reference?.state === "FINISHED";

  const actions = link
    ? [
        <Button
          asChild
          key="links"
          variant="white"
          onClick={() =>
            analytics.track({
              event: triviaUnstarted
                ? HallowAnalyticsEvent.TappedStartTrivia
                : triviaFinished
                  ? HallowAnalyticsEvent.TappedTriviaSummary
                  : HallowAnalyticsEvent.TappedResumeTrivia,
              properties: {
                game_id: item?.reference?.id,
                trivia_id: item?.reference?.id,
              },
            })
          }
        >
          <Link href={"/trivia"}>
            {t(
              triviaUnstarted
                ? "web_start_trivia"
                : triviaFinished
                  ? "web_review_trivia"
                  : "resume_trivia",
            )}
          </Link>
        </Button>,
      ]
    : null;

  const tags = item?.reference
    ? [
        t("x_playing_plural", {
          x_playing_plural: item.reference.player_count,
        }),
        t("ends_in_hours", {
          ends_in_hours: differenceInHours(
            new Date(item.reference.ends_at),
            new Date(),
          ),
        }),
      ]
    : null;

  return {
    actions,
    centerActions: actions,
    color: item?.reference?.images?.color_hex as CSSColorStrict,
    imgSrc: item?.reference?.images,
    summary: triviaFinished ? item?.reference?.summary : null,
    questions: !triviaUnstarted ? item?.reference?.questions : null,
    tags,
  };
};
